export const openSnackbar = (message, onActionClick) => ({
  type: 'OPEN_SNACKBAR',
  message,
  onActionClick,
});

export const closeSnackbar = () => ({
  type: 'CLOSE_SNACKBAR',
});
